var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card" }, [
    _c(
      "div",
      { staticClass: "card-content" },
      [
        _c("div", { staticClass: "level" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "level-right" }, [
            _vm.isSwitched &&
            _vm.$store.getters.hasAnyRole([
              "lyris",
              _vm.constants.STRINGS.ROLES.LYRIS_SOPORTE.ID,
            ])
              ? _c("div", { staticClass: "level-item" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button is-light",
                      on: { click: _vm.instalar },
                    },
                    [
                      _vm._v(
                        "\n                        Modificar\n                    "
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.$store.getters.hasAnyRole([
              "lyris",
              _vm.constants.STRINGS.ROLES.LYRIS_SOPORTE.ID,
            ])
              ? _c(
                  "div",
                  { staticClass: "level-item" },
                  [
                    _c(
                      "b-switch",
                      {
                        nativeOn: {
                          click: function ($event) {
                            return _vm.watchInput.apply(null, arguments)
                          },
                        },
                        model: {
                          value: _vm.isSwitched,
                          callback: function ($$v) {
                            _vm.isSwitched = $$v
                          },
                          expression: "isSwitched",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.isSwitched ? "Habilitado" : "Deshabilitado"
                          )
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.$store.getters.hasAnyRole(["admin"])
              ? _c("div", { staticClass: "level-item" }, [
                  _c("i", {
                    staticClass: "fas fa-lg fa-fw",
                    class: _vm.isSwitched ? "fa-check" : "fa-info-circle",
                  }),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.isSwitched
                          ? "Habilitado"
                          : "Consulte con Lyris para contratar el servicio"
                      ) +
                      "\n                "
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "columns" }, [
          _c("div", { staticClass: "column" }, [
            _c("div", { staticClass: "content" }, [
              _c("p", [_vm._v(_vm._s(_vm.about.descripcion))]),
            ]),
          ]),
          _vm._v(" "),
          _vm.settings
            ? _c("div", { staticClass: "column is-4" }, [
                _c("div", { staticClass: "content is-small" }, [
                  _c("table", { staticClass: "table is-narrow is-bordered" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _vm.settings && _vm.settings.parametros != null
                      ? _c(
                          "tbody",
                          _vm._l(
                            _vm.settings.parametros,
                            function (param, index) {
                              return _c("tr", { key: index }, [
                                _c("th", [_vm._v(_vm._s(index))]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(param))]),
                              ])
                            }
                          ),
                          0
                        )
                      : _c("tbody", [_vm._m(2)]),
                  ]),
                ]),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("installer", {
          attrs: {
            idOrganization: _vm.idOrganization,
            "id-modulo": _vm.about.id,
            params: _vm.settings,
            "show-installer": _vm.showInstaller,
          },
          on: {
            "update:showInstaller": function ($event) {
              _vm.showInstaller = $event
            },
            "update:show-installer": function ($event) {
              _vm.showInstaller = $event
            },
            cancelarInstalar: _vm.cancelarInstalar,
            cancelarReinstalar: _vm.cancelarReinstalar,
            instalado: _vm.instalado,
          },
        }),
        _vm._v(" "),
        _vm.settings != undefined
          ? _c("uninstall", {
              attrs: {
                "show-uninstaller": _vm.showUninstaller,
                idOrganization: _vm.idOrganization,
                modulo: _vm.settings.modulo_id,
              },
              on: {
                "update:showUninstaller": function ($event) {
                  _vm.showUninstaller = $event
                },
                "update:show-uninstaller": function ($event) {
                  _vm.showUninstaller = $event
                },
                cancelarDesinstalar: _vm.cancelarDesinstalar,
                desinstalado: _vm.desinstalado,
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "level-left" }, [
      _c("div", { staticClass: "level-item" }, [
        _c("h1", { staticClass: "title is-4" }, [
          _c("i", { staticClass: "fas fa-cube fa-fw" }),
          _vm._v(" Repositorios"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c(
          "th",
          { staticClass: "has-text-centered", attrs: { colspan: "2" } },
          [_vm._v("Configuración del módulo")]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { staticClass: "has-text-centered", attrs: { colspan: "2" } }, [
        _vm._v("El módulo no tiene parámetros configurables"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }